import React, { ReactElement, ReactNode } from 'react';
import { Box, Flex, TextInput, Pane, Text, InlineLink, IconButton } from '@fullstory/components';
import css from './index.module.scss';
import { FormattedMessage } from 'react-intl';
import { ElementApiNameAttribute } from '@fullstory/client-api';
import { intl } from '@fullstory/intl';
import classNames from 'classnames';

interface ApiSelectorInputProps {
  apiName: string;
  editable: boolean;
  onChange: (apiName: string) => void;
  onDelete?: () => void;
  onFocus?: () => void;
  active?: boolean;
  Appearances?: ReactElement;
}

export const ApiSelectorInput: React.FC<ApiSelectorInputProps> = ({
  apiName,
  editable,
  onChange,
  onDelete,
  onFocus,
  active,
  Appearances,
}) => (
  <Pane
    data-component="ApiSelectorInput"
    border="standard"
    borderRadius={4}
    className={classNames(css.selectorInput, { [css.active]: active })}
  >
    <>
      <Box padding={8} marginBottom={Appearances ? 4 : 0}>
        <Box marginBottom={8}>
          <Flex justifyContent="flex-start">
            <Box marginRight={12}>
              <Flex justifyContent="space-between">
                <Box className={css.selectorInput}>
                  <Box marginBottom={8}>
                    <Text appearance="bodyMediumBold">
                      <FormattedMessage defaultMessage="Attribute" id="OsU2Fs" />
                    </Text>
                  </Box>
                  <TextInput
                    onChange={() => {}}
                    value={ElementApiNameAttribute}
                    disabled
                    testId="api-element-attribute"
                    aria-labelledby="api-element-attribute"
                  />
                </Box>
              </Flex>
            </Box>
            <Box width="100%">
              <Flex justifyContent="space-between">
                <Box className={css.selectorInput}>
                  <Box marginBottom={8}>
                    <Text appearance="bodyMediumBold">
                      <FormattedMessage defaultMessage="API Name" id="oWmX3e" />
                    </Text>
                  </Box>
                  <Flex gap="8px" justifyContent="space-between">
                    <TextInput
                      onChange={e => {
                        if (editable) {
                          onChange(e.target.value);
                        }
                      }}
                      onFocus={onFocus}
                      onBlur={() => {}}
                      value={apiName}
                      testId="api-element-selector"
                      aria-labelledby="api-selector"
                    />
                    {editable && (
                      <IconButton
                        iconName="close"
                        title={intl.formatMessage({ defaultMessage: 'Close', id: 'rbrahO' })}
                        variant="minimal"
                        onClick={onDelete}
                        testId="delete-api-attribute-icon"
                      />
                    )}
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </Flex>
        </Box>
        <Box>
          <Text appearance="bodySmall" color="secondary">
            <FormattedMessage
              defaultMessage="Elements are automatically created by Fullstory when data-fs-element attributes are found. <a>Learn More</a>"
              id="93xGi2"
              values={{
                a(linkText: ReactNode) {
                  return (
                    <InlineLink
                      href="https://developer.fullstory.com/browser/auto-capture/set-element-properties/"
                      newTab
                    >
                      {linkText}
                    </InlineLink>
                  );
                },
              }}
            />
          </Text>
        </Box>
      </Box>
      {/* todo (kevin): add validation error states */}
      {Appearances}
    </>
  </Pane>
);
